<div class="spinner-container" *ngIf="!checkLoadedResend()">
    <mat-spinner class="content-box"></mat-spinner>
</div>

<mat-card appearance="outlined" class="mat-elevation-z8" *ngIf="checkLoadedResend()">
    <mat-card-content class="container">
        <div class="title-container">
            <div class="row-title">
                <span><b> {{'reportsTabTexts.numberOfRegisteredUsers' | translate}} </b></span> <span>&nbsp;
                    <b>{{this.countUsers}}</b></span>
            </div>
            <div class="row-subtitle">
                <span><b> {{'reportsTabTexts.asOfDate' | translate}} </b> </span> <span>&nbsp;
                                <b>{{this.currentDate | date: 'dd-MM-yyyy'}}</b></span>        
            </div>
        </div>    
        <form [formGroup]="formReport" (ngSubmit)="submitFormReport()">
            <div class="search-contents">
                <div class="custom-row">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label> {{'reportsTabTexts.role' | translate}}</mat-label>
                    <mat-select formControlName="role" multiple>
                        <mat-option *ngFor="let option of selectRoles" [value]="option">
                            {{ 'reportsTabTexts.roles.' + option | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>{{'reportsTabTexts.service' | translate}}</mat-label>
                    <mat-select formControlName="service" multiple>

                        <ng-container *ngFor="let option of selectServices">
                            <mat-option *ngIf="option.serviceType !== 'REPORTS'" [value]="option.serviceType">
                                {{ ('reportsTabTexts.serviceTypes.' + option.serviceType) | translate }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                </div>

                 <div class="custom-row">
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'reportsTabTexts.fromDate' | translate}}</mat-label>
                        <input matInput [matDatepicker]="fromDatePicker" formControlName="fromDate"
                            [max]="fromDateMax">
                        <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
                        <button *ngIf="formReport.get('fromDate')?.value" matSuffix mat-icon-button
                            (click)="clearField('fromDate')">
                            <cqes-icon icon="close"></cqes-icon>
                        </button>
                        <mat-datepicker #fromDatePicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'reportsTabTexts.toDate' | translate}}</mat-label>
                        <input matInput [matDatepicker]="toDatePicker" formControlName="toDate"
                            [min]="fromDateValue" [max]="currentDate">
                        <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                        <button *ngIf="formReport.get('toDate')?.value" matSuffix mat-icon-button
                            (click)="clearField('toDate')">
                            <cqes-icon icon="close"></cqes-icon>
                        </button>
                        <mat-datepicker #toDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                
                <div class="custom-row">
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'reportsTabTexts.status' | translate}}</mat-label>
                        <mat-select formControlName="status" multiple>
                            <mat-option *ngFor="let option of statusesLabels" [value]="option">
                                {{ option.label | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row-content-right">
                <button mat-raised-button type="submit"
                    [disabled]="formReport.invalid || isSubmitting">{{'reportsTabTexts.search' | translate}}</button>
                <button mat-button (click)="exportExcel()" [disabled]="!hasData()" type="button"
                    class="mat-mdc-raised-button">{{
                    'common.exportExcel' | translate }}</button>
            </div>
        </form>
        <div class="data-container" [hidden]="!hasData() || isLoading">
            <div class="mat-elevation-z8 table-content">
                <div>
                    <mat-table [dataSource]="reportDataSource" matSort (matSortChange)="sortData($event)">
                    <ng-container matColumnDef="number">
                        <mat-header-cell *matHeaderCellDef class="narrow-column">№</mat-header-cell>
                        <mat-cell *matCellDef="let row; let i = index" class="narrow-column">
                            <div class="cell">
                                {{ i + 1 }}
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef="let name" appResizableColumn>
                            {{'reportsTabTexts.name' | translate}}

                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <div class="cell">

                                <span>{{ getName(row) }}</span>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="position">
                        <mat-header-cell *matHeaderCellDef="let position">
                            {{'reportsTabTexts.position' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">{{row?.position}}

                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="role">
                        <mat-header-cell *matHeaderCellDef="let role">
                            {{'reportsTabTexts.role' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            {{ 'reportsTabTexts.roles.' + row.role | translate }}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="service">
                        <mat-header-cell *matHeaderCellDef="let service" class="header-cell-custom" appResizableColumn>
                            {{'reportsTabTexts.service' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="header-cell-custom">
                            <div class="cell-service">
                                <div *ngFor="let serviceType of getAllServiceTypesFlat(row)" class="service-item">
                                    {{ serviceTypeLabels[serviceType] || serviceType }}
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="registrationDate">
                        <mat-header-cell mat-sort-header *matHeaderCellDef="let registrationDate">
                            {{'reportsTabTexts.registrationDate' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <div class="cell">
                                {{row.registrationDate | date:'short'}}
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef="let status">
                            <div class="status-head"> {{'reportsTabTexts.status' | translate}}
                            </div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <div class="cell">
                                <div *ngIf="row.status === 'ACTIVE'"
                                    matTooltip="{{ 'reportsTabTexts.active' | translate }}">
                                    <cqes-icon icon="person"></cqes-icon>
                                </div>

                                <div *ngIf="row.status === 'BLOCKED' || row.status === 'INACTIVE'"
                                    matTooltip="{{ 'reportsTabTexts.deactivate' | translate }}" class="icon-content">
                                    <cqes-icon icon="person"></cqes-icon>
                                    <div class="second">
                                        \
                                    </div>
                                </div>
                                <div *ngIf="row.status === 'DELETED'"
                                    matTooltip="{{ 'reportsTabTexts.deleted' | translate }}" class="icon-content">
                                    <cqes-icon icon="person" class="text-danger"></cqes-icon>
                                    <div class="second">
                                        \
                                    </div>
                                </div>
                                <div *ngIf="row.status === 'PENDING'"
                                    matTooltip="{{ 'reportsTabTexts.deactivate' | translate }}" class="icon-content">
                                    <cqes-icon icon="person" class="text-warning"></cqes-icon>
                                    <div class="second">
                                        \
                                    </div>
                                </div>

                            </div>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;" class="expand-element-row">
                    </mat-row>
                    </mat-table>
                </div>
                <mat-paginator [length]="totalCountPages" [pageSizeOptions]="[5, 10, 20, 50]" [pageSize]="limit"
                    showFirstLastButtons (page)="onPaginateChange($event)">
                </mat-paginator>
            </div>
        </div>
    </mat-card-content>
</mat-card>